import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-img-big',
  templateUrl: './img-big.component.html',
  styleUrls: ['./img-big.component.css']
})
export class ImgBigComponent implements OnInit {

  @Input() imgBig_params: any = {}


  constructor() { }

  ngOnInit(): void {
  }

}
